import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* editNpcEntry(action: any): any {
  try {
    yield put({ type: npcLogConstant.EDIT_NPC_ENTRY_LOADER });
    const response = yield call(npcLogService.editNpcEntry, action.payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: npcLogConstant.EDIT_NPC_ENTRY_SUCCESS,
        payload: { response: response.data, status: response?.status },
      });
    } else {
      throw response;
    }
  } catch (error: any) {
    yield put({
      type: npcLogConstant.EDIT_NPC_ENTRY_FAILURE,
      payload: { response: error?.response?.data, status: error?.response?.status },
    });
  }
}

function* editNpcEntrySaga() {
  yield takeEvery(npcLogConstant.EDIT_NPC_ENTRY_REQUEST, editNpcEntry);
}

export default editNpcEntrySaga;
